import { render, staticRenderFns } from "./AncestrylineModal.vue?vue&type=template&id=de96102a&scoped=true&"
import script from "./AncestrylineModal.vue?vue&type=script&lang=js&"
export * from "./AncestrylineModal.vue?vue&type=script&lang=js&"
import style0 from "./AncestrylineModal.vue?vue&type=style&index=0&id=de96102a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96102a",
  null
  
)

export default component.exports